import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { SaveMapDialogService, SaveMapParams } from './save-map-dialog-service.';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { MapIOOptions } from 'src/app/model/api-services/map-api.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { EnvService } from 'src/app/env.service';

@Component({
  selector: 'app-save-map-dialog',
  templateUrl: './save-map-dialog.component.html',
  styleUrls: ['./save-map-dialog.component.scss']
})
export class SaveMapDialogComponent implements OnInit {
  title = 'Save Map';
  queryVisOnly:string = '';
  public options: MapIOOptions = {
    location: true,
    layerOrder: true,
    layerSettings: true,
    baseMap: true,
    ThreeD: true,
    selectionStyles: true,
    queryVis: true,
    asNew: {
      on: false,
      name: '',
      openAfter: true
    }
  };
  private map!: ISLMap;
  @HostBinding('class.work-view') workView = true;

  constructor(private activeModal: NgbActiveModal, private messager: ModalMessagerService, private env: EnvService) { }

  ngOnInit() {
  }
  Show(params: SaveMapParams) {
    if (this.options?.asNew) {
      this.options.asNew.name = 'Copy of ' + params.map.project.name;
    }
    this.map = params.map;
    this.queryVisOnly = (this.map.component.queryAllSearchableLayers === false) ? 'Yes' : 'No';
  }
  Save(): void {
    this.messager.Progress('Sending map info to server', false, .5, 'Saving Map Info');
    this.map.Save(this.options).then((response) => {
      if (!(!!response)) {
        return;
      }
      this.messager.Progress('Data sent to server, processing response', false, .75, 'Saving Map Info');
      if (!!response.message) {
        this.messager.Progress('', true, 1, 'Saving Map Info');
        this.messager.CancelProgress('Saving Map Info');
        this.messager.Notify(response.message.split(':').pop(), true, 'A problem was encountered');
        return;
      }
      if (!!response.openAfter) {
        if (response.openAfter === 1) {
          window.open(this.env.GetAppURL() + response.mapId, '_blank');
          this.messager.Progress(
            'Complete; Your new map id is '
            + response.mapId
            + ', it has been open in another window/tab',
            true, 1, 'Saving Map Info');
        } else {
          this.messager.Progress(
            'Complete; Your new map id is '
            + response.mapId,
            true, 1, 'Saving Map Info');
        }
      } else {
        this.messager.Progress(
          'Complete, the map changes you specified have been saved',
          true, 1, 'Saving Map Info');
      }
      this.activeModal.close();

    });
  }
  Cancel(): void {
    this.activeModal.close();
  }
}

@Component({
  selector: 'app-save-map-dialog-entry',
  template: ''
})
export class SaveMapDialogEntryComponent implements OnDestroy {
  modalRef!: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: SaveMapDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(SaveMapDialogComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as SaveMapDialogComponent).Show(info);
    });
  }
  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }

}


